import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import PhoneIcon from "@mui/icons-material/Phone";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import toast from "react-hot-toast";
import API from "../API";

const holidayStaffList = [
    {
        staff_firstname: "Select",
        staff_lastname: "Staff",
        hubspot_id: "",
    },
    {
        staff_firstname: "Megana",
        staff_lastname: "",
        hubspot_id: "489887566",
    },
    {
        staff_firstname: "Ganganatha",
        staff_lastname: "Perera",
        hubspot_id: "749106092",
    },
    {
        staff_firstname: "Alyn",
        staff_lastname: "Fundal",
        hubspot_id: "89243545",
    },
    {
        staff_firstname: "Hiyam",
        staff_lastname: "Wedatallah",
        hubspot_id: "81839437",
    },
    {
        staff_firstname: "Kunaal",
        staff_lastname: "Nanik",
        hubspot_id: "87506737",
    }
];

export default function CustomerForm() {
    const navigate = useNavigate();
    const { id } = useParams();

    const location = useLocation();
    const currentPage = location.state?.currentPage || 1;
    const search = location.state?.search || "";
    const search2 = location.state?.search2 || "";
    const search4 = location.state?.search4 || "";
    const searchDate = location.state?.searchDate || "";
    const search8 = location.state?.search8 || "";
    const search7 = location.state?.search7 || "";
    const search9 = location.state?.search9 || "";
    const search10 = location.state?.search10 || "";
    const searchCountry = location.state?.searchCountry || "";

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [holidayStaff, setHolidayStaff] = useState("");
    const [isGroupStudent, setIsGroupStudent] = useState(false);
    const [groupTour, setGroupTour] = useState("");
    const [ticketId, setTicketId] = useState("");

    async function fetchData() {
        try {
            setIsLoading(true);

            const response = await API.get(
                `/ivisa/edit/${id}`
            );

            setData(response.data);
        }
        catch (error) {
            if (error.response && error.response.status === 401) {
                navigate('/login');
            }
        }
        finally {
            setIsLoading(false);
        }
    };

    async function updateData() {
        try {
            setIsLoading(true);
            if (isGroupStudent && !window.confirm("Marking the customer as a group student will not send any visa approval email to this customer. Do you want to continue?")) {
                return;

            }
            if (!isGroupStudent && holidayStaff && !window.confirm("Setting the holiday staff means the email template to be sent on visa approval will be changed for this customer. Do you want to continue?")) {
                return;
            }

            const selectedStaff = holidayStaffList.find(staff => staff.hubspot_id === holidayStaff);
            const selectedStaffName = selectedStaff ? `${selectedStaff.staff_firstname} ${selectedStaff.staff_lastname}` : "";

            let updatedData = {
                holiday_staff: {
                    ticketId: ticketId ? ticketId : '',
                    name: selectedStaffName,
                    hubspotId: holidayStaff ? holidayStaff : "",
                },
                isGroupStudent: isGroupStudent ? isGroupStudent : false,
                groupTour: groupTour ? groupTour : "",
            };

            const result = await API.patch(
                `/ivisa/edit/customer-type/${id}`,
                updatedData
            );

            setData(result.data);

            if (result.status === 200) {
                toast.success("Customer Type Updated Successfully.");
            }
            else {
                toast.error("Error updating customer type.");
            }
        }
        catch (error) {
            toast.error("Error updating customer type.");
            console.error(error);
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (data) {
            setHolidayStaff(data.holiday_staff?.hubspotId || "");
            setIsGroupStudent(data.isGroupStudent || false);
            setGroupTour(data.groupTour || "");
            setTicketId(data.holiday_staff?.ticketId || "");
        }
    }, [data]);

    return (
        <>
            <Button
                variant="contained"
                sx={{ margin: "5px" }}
                onClick={() =>
                    navigate("/visa/applications", {
                        state: {
                            currentPage: currentPage,
                            search: search,
                            search2: search2,
                            search4: search4,
                            searchDate: searchDate,
                            search8: search8,
                            search7: search7,
                            search9: search9,
                            search10: search10,
                            searchCountry: searchCountry,
                        },
                    })
                }
            >
                <ArrowBackIcon /> &nbsp;Go Back
            </Button>
            <Button
                variant="contained"
                sx={{ margin: "5px" }}
                onClick={() =>
                    navigate(`/visa/edit/${data._id}`, {
                        state: {
                            currentPage: currentPage,
                            search: search,
                            search2: search2,
                            search4: search4,
                            searchDate: searchDate,
                            search8: search8,
                            search7: search7,
                            search9: search9,
                            search10: search10,
                            searchCountry: searchCountry,
                        },
                    })
                }
            >
                <EditIcon /> &nbsp;Go To Application Edit
            </Button>
            <Button
                variant="contained"
                sx={{ margin: "5px" }}
                onClick={() =>
                    navigate(`/visa/edit/contact/${data._id}`, {
                        state: {
                            currentPage: currentPage,
                            search: search,
                            search2: search2,
                            search4: search4,
                            searchDate: searchDate,
                            search8: search8,
                            search7: search7,
                            search9: search9,
                            search10: search10,
                            searchCountry: searchCountry,
                        },
                    })
                }
            >
                <PhoneIcon /> &nbsp;Go To Contact Edit
            </Button>
            <Box component="section" display="flex" alignItems="center" justifyContent="center"
                sx={{ height: "80vh", p: 2, border: "1px dashed grey", marginTop: "10px", width: "500px", margin: "auto" }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} >
                        <Typography variant="h5" gutterBottom component="div" sx={{
                            color: "red",
                        }}>
                            {data.name}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom component="div">
                            Customer Type
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <label htmlFor="hs_ticket_id">Hubspot Ticket ID (Holiday)</label>
                        <input
                            id="hs_ticket_id"
                            style={{ padding: "5px" }}
                            value={ticketId}
                            onChange={(e) => {
                                setTicketId(e.target.value);
                            }
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <label htmlFor="holiday_staff">Holiday Staff</label>
                        <select
                            className="form-select"
                            id="holiday_staff"
                            value={holidayStaff}
                            onChange={(e) => setHolidayStaff(e.target.value)}
                        >
                            <option value="">Select Staff</option>
                            {holidayStaffList.map((staff) => (
                                <option
                                    key={staff.hubspot_id || "default"}
                                    value={staff.hubspot_id}
                                >
                                    {`${staff.staff_firstname} ${staff.staff_lastname}`.trim()}
                                </option>
                            ))}
                        </select>
                    </Grid>


                    <Grid item xs={6} sm={6}>
                        <label htmlFor="group_tour">Group Tour</label>
                        <input
                            id="group_tour"
                            style={{ padding: "5px" }}
                            placeholder="e.g. AUS SBA Japan 2025"
                            value={groupTour}
                            onChange={(e) => {
                                setGroupTour(e.target.value);
                            }}
                            disabled={!isGroupStudent}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="secondary"
                                    name="group_student"
                                    value={isGroupStudent}
                                    checked={isGroupStudent}
                                    onChange={(e) => {
                                        setIsGroupStudent(e.target.checked);
                                    }}
                                />
                            }
                            label="Applicant is a Group Student"
                        />
                    </Grid>
                </Grid>
                <button type="submit" className={`btn btn-success col-2 fixed-bottom`}
                    disabled={isLoading} onClick={updateData}>
                    Save
                </button>
            </Box>
            <style>
                {`
                    input{
                        border: 1px solid #393f81;
                        border-radius: 5px;
                        padding: 5px;
                    }
                    input::placeholder{
                        opacity: 0.5;
                    }
                `}
            </style>
        </>
    );
}